import React from 'react';
import { useStateSelector } from '../../../providers/stateManager';
import { selectFiles } from '../../../utils/selectors';
import { stateKeys } from '../../../constants/stateKeys';
import Files from '../../Files';
import { useRemoveFile } from '../../../services/removeFileFromState';

const FilesBlock = ({ commentId }) => {
  const files = useStateSelector(selectFiles);

  const removeFile = useRemoveFile(stateKeys.files);

  if (!files?.length) return null;

  return (
    <Files
      data={files}
      commentId={commentId}
      removeFile={removeFile}
      layout="vertical"
    />
  );
};

export default FilesBlock;
